import { ReactNode } from 'react';

import { X } from 'lucide-react';

import useToggleOptionalField from './useToggleOptionalField';

export interface ToggleOptionalFieldProps {
  fieldName: string;
  buttonLabel: string;
  children: ReactNode;
  initalValue: unknown;
  className?: string;
  removeButtonClassName?: string;
  showRemove?: boolean;
  initiallyVisible?: boolean;
}

const ToggleOptionalField: React.FunctionComponent<ToggleOptionalFieldProps> =
  function ({
    fieldName,
    buttonLabel,
    children,
    initalValue,
    className = '',
    removeButtonClassName = '',
    showRemove = true,
    initiallyVisible = false,
  }) {
    const { visible, onAddClick, onRemoveClick } = useToggleOptionalField(
      fieldName,
      initalValue,
      initiallyVisible,
    );
    return (
      <div className={`w-full ${className}`}>
        {visible && (
          <div className="flex flex-row">
            {children}
            {showRemove && (
              <button
                type="button"
                onClick={onRemoveClick}
                className={`ml-1 ${removeButtonClassName}`}
              >
                <X size={20} />
              </button>
            )}
          </div>
        )}
        {!visible && (
          <button
            type="button"
            className="w-full px-2 py-2.25 border border-dashed text-13-14 border-neutral-300 rounded text-neutral-700"
            onClick={onAddClick}
          >
            + {buttonLabel}
          </button>
        )}
      </div>
    );
  };

export default ToggleOptionalField;
